<template>
  <div>
    <page-header
      header="Print Order Form"
    />
    <div>
      <div class="flex -mx-6">
        <div class="w-full px-6 flex">
          <div class="p-6 bg-white rounded-lg flex-1">
            <h2 class="font-medium border-bottom pb-4 mb-4">
              Custom QR Code Maker
            </h2>
              <div class="flex h-full w-full flex-col items-center px-4">
                <div class="bg-white mt-5 rounded p-3  w-full">
                  <div class="w-full flex flex-col md:flex-row justify-between border-b">
                    <div class="flex-1 flex flex-col items-center md:flex-row align-middle">
                      <button @click="tab = 'options'" class="p-3 text-grey text-lg font-bold md:mr-3 pr-16 border-right flex items-center">
                        <div class="w-8 h-8 text-white float-left" :class="tab === 'options' ? 'bg-tertiary' : 'bg-grey-dark'">
                          <icon name="qrcode-icon" class="text-white" />
                        </div>
                        <span class="border-b-2 border-white p-2" :class="tab === 'options' ? 'text-grey-darkest' : 'text-grey-dark'">Create a QR Code</span>
                      </button>
                      <button @click="tab = 'export'" class="p-3 text-grey text-lg font-bold pl-4 md:mr-3 flex items-center">
                        <div class="w-8 h-8 text-white float-left" :class=" tab === 'export' ? 'bg-tertiary' : 'bg-grey-dark'">
                          <icon name="qrcode-icon" class="text-white" />
                        </div>
                        <span class="border-b-2 border-white p-2" :class="tab === 'export' ? 'text-grey-darkest' : 'text-grey-dark'">Saved QR Codes</span>
                      </button>
                    </div>
                  </div>
                  <div v-show="tab === 'options'">
                    <qr-generator-create></qr-generator-create>
                  </div>
                  <panel v-if="tab === 'export' " class="pt-6 mt-y" @click="reloadHistory=true">
                    <qr-generator-save></qr-generator-save>
                  </panel>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrGeneratorCreate from './QrGeneratorCreate'
import QrGeneratorSave from './QrGeneratorSave'

export default {
  data () {
    return {
      tab: 'options'
    }
  },
  components: {
    QrGeneratorCreate,
    QrGeneratorSave
  }
}
</script>

<style scoped>
button:focus {
  outline:0;
}
</style>
